import { useState } from "react";

import { SharableProfileDialog } from "@ui/components/SharableProfile/components/SharableProfileDialog/SharableProfileDialog";
import { ShareProfileButton } from "@ui/components/SharableProfile/components/ShareProfileButton/ShareProfileButton";

import type { ContactPersonal } from "@jti/fe-common";

import styles from "./SharableProfile.module.scss";

type SharableProfileProps = {
  userInfo: ContactPersonal;
  userId: string;
  referralCode: string;
  isDialogOpenedManually?: boolean;
  portalDomNode?: HTMLElement;
};

export const SharableProfile: React.FC<SharableProfileProps> = ({
  userInfo,
  userId,
  referralCode,
  isDialogOpenedManually = false,
  portalDomNode,
}) => {
  const [isShareProfileDialogOpened, setIsShareProfileDialogOpened] = useState(isDialogOpenedManually);

  const toggleDialog = () => {
    setIsShareProfileDialogOpened((prevState) => !prevState);
  };

  return (
    <>
      <div className={styles.mobileScreenButtonWrapper}>
        <ShareProfileButton toggleDialog={toggleDialog} size="sm" fullWidth />
      </div>
      <div className={styles.buttonWrapper}>
        <ShareProfileButton toggleDialog={toggleDialog} size="lg" />
      </div>
      <SharableProfileDialog
        userInfo={userInfo}
        userId={userId}
        referralCode={referralCode}
        isOpened={isShareProfileDialogOpened}
        onClose={toggleDialog}
        portalDomNode={portalDomNode}
      />
    </>
  );
};
